export default __webpack_public_path__ + "static/media/antp_ingvehicular_JoseManuel_movil.0bfe072f.jpg";